<template>
	<v-app class="landing" :style="{ background: $vuetify.theme.themes[theme].landingBackground }">
		<default-bar />

		<second-bar />

		<default-view />

		<default-footer />

	</v-app>
</template>

<script>
	import { get, call } from 'vuex-pathify'
	import { setCookie, getCookie } from '@/util/helpers'
	import api from '@/util/app-api'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'DefaultLayout',

		components: {
			DefaultBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./AppBar'
			),
			SecondBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./SecondAppBar'
			),
			DefaultFooter: () => import(
				/* webpackChunkName: "default-footer" */
				'./Footer'
			),
			DefaultView: () => import(
				/* webpackChunkName: "default-view" */
				'./View'
			),
		},
		computed: {
			theme() {
				return (this.$vuetify.theme.dark) ? 'dark' : 'light'
			},
			...get('siteConfig', [
				'isCloud'
			])
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
			// if (!this.isCloud)
			// 	router.push({ name: 'Login' }).catch(() => { })
		},
		mounted() {
			this.manageAffiliate()
			this.manageAgentCode()
		},
		methods: {
			manageAffiliate() {
				let mrk = this.$route.query.mrk
				if (!mrk)
					return

				setCookie('mrk', mrk, 180)

				let customerCode = this.$route.params.customerCode || 0
				api.post(`Visitor/LogVisitor/?customerCode=${customerCode}&mrkCode=${mrk}`, {}, { authHeader: false, contentType: 'application/json' })
					.then(response => {
					})
					.catch(err => {
					})
			},
			manageAgentCode() {
				let agn = this.$route.query.agn
				if (!agn)
					return

				setCookie('agn', agn, 180)
			}
		},
	}
</script>
